import React from "react";

const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }

const Footer = () => (

  <footer className="text-white py-12 px-4">
    <div className="max-w-[1240px] mx-auto flex flex-col md:flex-row gap-12 md:gap-8">
      {/* About Me Section */}
      <div className="flex-1 min-w-[220px]">
        <h2 className="text-2xl font-bold mb-3 text-[#00df9a]">About Me</h2>
        <p className="text-gray-300">
          I’m Marcin, a passionate software engineer who loves turning ideas into robust, beautiful web experiences. Let’s create something amazing together!
        </p>
      </div>
      {/* Footer Columns */}
      <div className="flex flex-col sm:flex-row flex-1 gap-8">
        <div className="flex-1 min-w-[150px]">
          <h3 className="font-semibold mb-2 text-[#00df9a]">Contact</h3>
          <ul className="text-gray-400">
            <li>Email: em.dubinski@gmail.com</li>
            <li>LinkedIn: /in/marcin</li>
            <li>GitHub: /surfingnerdinc</li>
          </ul>
        </div>
        <div className="flex-1 min-w-[150px]">
          <h3 className="font-semibold mb-2 text-[#00df9a]">Quick Links</h3>
          <ul className="text-gray-400">
            <li className="hover:underline" onClick={() => scrollToSection('home')}>Home</li>
            <li className="hover:underline" onClick={() => scrollToSection('about')}>About</li>
            <li className="hover:underline" onClick={() => scrollToSection('projects')} >Projects</li>
            <li className="hover:underline" onClick={() => scrollToSection('contact')}>Contact</li>
          </ul>
        </div>
        <div className="flex-1 min-w-[150px]">
          <h3 className="font-semibold mb-2 text-[#00df9a]">Curious?</h3>
          <p className="text-gray-400">
            Not sure where to start? <br />
            <a href="#contact" className="text-[#00df9a] hover:underline">Let’s talk!</a>
          </p>
        </div>
      </div>
    </div>
    <div className="mt-10 text-center text-gray-500 text-sm">
      &copy; {new Date().getFullYear()} Marcin De. All rights reserved.
    </div>
  </footer>
);

export default Footer;